import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

export const usePermission = () => {
    const { permissions } = useSelector((state: RootState) => state.userInfo);

    return (list: string[]): boolean => {
        for (const l of list) {
            if (permissions.includes(l)) {
                return true;
            }
        }

        return false;
    };
};
